import { Component,OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {MatBottomSheet } from '@angular/material';
import { AngularFireAuth } from '@angular/fire/auth';
//import { ShareButtons } from '@ngx-share/core';
import { PostService,UrlAttachmentService,ImageService } from '../../services/firebase/firebase.service';
import {SeoService} from '../../services/seo/seo.service';

import {map} from 'rxjs/operators';
import { Post,UrlAttachment,Image } from '../../models/models';
import { DeletePostActions } from '../../components/components';
import { LoadingBarService } from '@ngx-loading-bar/core';



/**
 * Generated class for the PostPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-post',
  templateUrl: 'post.html',
  styleUrls: ['./post.scss']
})
export class PostPage implements OnInit {
		
	post;
	user;
	id;
	//Construtor
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private afAuth: AngularFireAuth,
		private postService:PostService,
		private image:ImageService,
		private url_attachment:UrlAttachmentService,
		private bottomSheet: MatBottomSheet,
		private loadingBar: LoadingBarService,
		private seo: SeoService,
		private _titleService:Title){}

	ngOnInit() {

		this.loadingBar.start();
				
		
	  	//Pegar Estado do Usuario
		this.afAuth.auth.onAuthStateChanged((user)=> {
			if(user) {
				this.user = user;
			}
		});	
		
		//Pegar id do post "post/:id"
		this.id = this.route.snapshot.paramMap.get('id');
		
		//Iniciar pegar dados do post
		this.post = this.postService.getPost(this.id).snapshotChanges().pipe(
			map(data => {
				let post =   (data.payload.data() as Post);
				if(!post) return;
				
				this.seo.generateTags({
					title: 'Microblog - Meu Post', 
					description:`${post.text.substr(0,50)}`, 
					slug:`post/${this.id}`
				});


			  	this._titleService.setTitle('Microblog Felipe Mateus - Meu Post');

				
				if(post.url_attachment_id){
					
					this.url_attachment.getUrlAttachment(post.url_attachment_id).valueChanges().subscribe(url=>{
						if(!url) return;
						post.url_attachment = url as UrlAttachment;
						post.url_attachment.img = this.image.getImage(post.url_attachment.image_id).valueChanges();
					});
				}
				this.loadingBar.complete()
				return post;
			})
		);		
	}
	
	deleteConfirm(){
		this.bottomSheet.open(DeletePostActions,{data:{post_id:this.id}});
	}
	
}